module.exports = __webpack_public_path__ + "img/item13.dc29d1fa.png";